export default {
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
    },

    card: {
        maxWidth: "714px",
        padding: "36px 60px",
        alignItems: "start"
    },

    invoiceLogo: {
        marginRight: "20px"
    },

    cardHeader: {
        display: "flex",
        alignItems: "baseline",
        marginBottom: "50px"
    },

    cardInfo: {
        display: "flex",
        alignItems: "center",
        marginBottom: "15px"
    },

    questionText: {
        fontSize: "20px",
        color: "#252323",
        marginTop: "50px"
    },

    buttonsContainer: {
        display: "flex",
        columnGap: "20px",
    },

    button: {
        padding: "8px 20px"
    },

    grayBorder: {
        width: "100%",
        margin: "20px 0px",
        borderBottom: "0.5px solid rgb(186, 177, 177,1)",
    },

    separator: {
        margin: "5px 0px",
        borderBottom: "0.5px solid rgb(186, 177, 177,1)",
    },

    einNumber: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "25px",
    }
}